import { gql } from "@outschool/ui-apollo";

export const BLOCK_SCOPED_THREADS_FOR_SECTION_QUERY = gql`
  query BlockScopedThreadsForSection($sectionUid: ID!, $searchQuery: String) {
    section(uid: $sectionUid) {
      uid
      end_time
      unreadBlockScopedThreadsCount
      blockScopedThreads(searchQuery: $searchQuery) {
        uid
        classPost {
          uid
          title
        }
        learningAssignmentClassPost {
          uid
          title
        }
        latestMessage {
          uid
          messageContent {
            uid
            text
            attachments {
              uid
              file {
                mimetype
              }
            }
            video {
              uid
            }
          }
          sentAt
        }
        unreadCount
      }
      leader {
        uid
        name
        photo
      }
    }
  }
`;
